import styles from './styles.module.scss';

type Button = {
  text: string,
  outline?: boolean,
  className? : string,
  onClick?: () => void
}

function Button(props : Button) : JSX.Element {
  const getClassName = () : string => props.outline ? 'biobar-button-outline' : 'biobar-button';

  const onClick = () : void => {
    if (props.onClick !== undefined)
      props.onClick();
  };

  return (
    <button
      onClick={onClick}
      className={`${styles[getClassName()]} ${!props.className ? '' : props.className}`}>
      {props.text}
    </button>
  );
}

export default Button;